import styled from 'styled-components'
import { Regular, MqTablet, MqDesktop, Sans } from 'streamr-ui/css/consts'

export const DiveIn = styled.div`
    margin-top: 5rem;
    text-align: center;

    h3 {
        display: none;
    }

    @media ${MqTablet} {
        h3 {
            display: block;
            font-family: ${Sans};
            font-size: 1.625rem;
            font-weight: ${Regular};
            line-height: 2rem;
            margin: 0;
            margin-bottom: 3rem;
        }
    }

    @media ${MqDesktop} {
        margin-top: 7.5rem;
    }
`
